import { useDataChange } from 'Simple/Data.js'

export default function useListItemDataOnChange(props) {
  let change = useDataChange({
    context: 'images',
    viewPath: props.viewPath,
  })

  return function onChange(next) {
    change(inext => {
      inext[props.index] = next
    })
  }
}
